import { Form, Input } from 'antd';
import InputNumber from 'global/Securities/components/Input/InputNumber';
import styled from 'styled-components';

export const FormItem = styled(Form.Item)`
  .ant-input:hover,
  .ant-input:focus,
  .ant-input-focused {
    border-color: #dadada;
    outline: 0;
    box-shadow: none;
  }

  &.ant-form-item-has-error {
    .ant-input:hover,
    .ant-input:focus,
    .ant-input-focused {
      border-color: #ff7875;
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
    }
  }

  & .ant-form-item-explain,
  .ant-form-item-extra {
    min-height: unset;
  }
`;

export const FormItemError = styled(FormItem)`
  .ant-form-item-explain {
    color: #ff4d4f;
  }
`;

export const FormItemRange = styled(FormItem)`
  margin-bottom: 0;
`;

export const QuantityInput = styled(Input)`
  & .ant-input-group > .ant-input:first-child,
  .ant-input-group-addon:first-child {
    padding-right: 50px;
    border-radius: 4px;
    text-align: right;
  }

  & span.ant-input-group-addon {
    background: transparent;
    position: absolute;
    top: 0;
    right: 0;

    width: fit-content;
    height: 100%;

    display: flex;
    align-items: center;

    border: none;
    color: #858585;
    z-index: 1;
  }
`;

export const QuantityAddon = styled.span`
  color: #858585;
`;

export const RangeWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & > div,
  span {
    margin-right: 8px;

    :last-child {
      margin-right: 0;
    }
  }
`;

export const RangeInput = styled(InputNumber).attrs({ disableHighlight: true })`
  padding: 6px 4px;
  text-align: center;
`;

export const InfoButton = styled.button`
  display: inline-flex;
  background: none;
  border: none;
  padding: 4px 0;
  margin: 0;

  cursor: pointer;
`;

export const RadioButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;

  input[type='radio']:checked + span {
    color: #00ab6b;
    border: 1px solid #00ab6b;
  }
`;

export const RadioButton = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  cursor: pointer;

  > input {
    display: none;
  }

  > span {
    font-size: 12px;
    line-height: 16px;
    padding: 6px 12px;
    color: #858585;
    border: 1px solid #858585;
    border-radius: 15px;
  }
`;
